export default {
  namespaced: true,
  state: () => ({
    active: false,
    endDate: ''
  }),
  getters: {
    inMaintenance: (state) => state.active,
    maintenanceEndDate: (state) => state.endDate
  },
  mutations: {
    setMaintenance: (state, { active, endDate }) => {
      if (active) {
        state.active = !!active
        state.endDate = endDate ?? ''
      } else {
        // In some instances pages might be broken or blank!
        // So reload to retrigger network requests and store will also be reset
        location.reload()
      }
    }
  },
  actions: {
    show({ commit }, { date = '' } = {}) {
      commit('setMaintenance', { active: true, endDate: date })
    },
    hide({ commit }) {
      commit('setMaintenance', { active: false, date: '' })
    }
  }
}
